exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.left-menu-drawer-root > div {\n  padding: 0 12px;\n  background-color: #f6f2f7;\n  border-right: none; }\n\ndiv.header-controls {\n  width: 35%;\n  text-align: right; }\n", ""]);

// exports
